import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    frundList: []
};

const getters = {
    getFrund: state => state.frundList
};

const actions = {
    getFrund({commit}) {
        axiosGet(`crm/frunds?all`).then(({data}) => {
            commit('FRUND_INFO', data)
        }).catch((error) => console.log(error));
    },
};

const mutations = {
    FRUND_INFO(state, data) {
        state.frundList = data;
    }
};


export default {
    state,
    getters,
    actions,
    mutations
}
